var render = function render(){var _vm=this,_c=_vm._self._c;return _c('app-router',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Early access'),expression:"'Early access'"}],staticClass:"inbox",attrs:{"to":{name: (_vm.$isPatreon) ? 'SessionPatreonAccess' : 'CommunityAccess'}}},[_c('div',{staticClass:"inbox-icon"},[_c('i',{staticClass:"fa-solid fa-flask"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }